import {Injectable} from '@angular/core';

import {ComplianceArea} from '../_models/index';

import {AuthenticationService} from './index';

import {Observable} from "rxjs";
import {LoginHelper} from '../helpers';
import {Load} from "../_decorators/loading.decorator";
import {HttpClient} from "@angular/common/http";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class ComplianceAreaService {
    constructor(public http: HttpClient,
                public authenticationService: AuthenticationService,
                public config: IndexConfigService) { }

    getComplianceAreasStatus(tenantName: string){

        if (tenantName == null){
            tenantName = LoginHelper.getTenantName();
            if (tenantName == null || LoginHelper.getUserToken() == null){
                this.authenticationService.logout();

                return null;
            }
        }

        return this.http
            .get<any>(this.config.api + '/api/complianceareas/status');
    }

  @Load()
  getInfoComplianceAreas(tenantName: string = null){

        if (tenantName == null){
            tenantName = LoginHelper.getTenantName();
        }

        if (tenantName == null || LoginHelper.getUserToken() == null){
            this.authenticationService.logout();

            return null;
        }

        return this.http
            .get<any>(this.config.api + '/api/complianceareas/info')
            ;
    }

    getComplianceAreas(tenantName: string = null){

    if (tenantName == null){
        tenantName = LoginHelper.getTenantName();
        if (tenantName == null || LoginHelper.getUserToken() == null){
            this.authenticationService.logout();

            return null;
        }
    }

    return this.http
        .get<any>(this.config.api + '/api/complianceareas/all')
        ;
    }

    getComplianceAreasProjectControlItems(projectId: number, tenantName: string = null){

        if (tenantName == null){
            tenantName = LoginHelper.getTenantName();
            if (tenantName == null || LoginHelper.getUserToken() == null){
                this.authenticationService.logout();

                return null;
            }
        }

        return this.http
            .get<any>(this.config.api + '/api/complianceareas/project/' + projectId)
            ;
    }


  getComplianceAreaUpdateCount(tenantName: string = null) {

    if (tenantName == null){
      tenantName = LoginHelper.getTenantName();
      if (tenantName == null || LoginHelper.getUserToken() == null){
        this.authenticationService.logout();

        return null;
      }
    }

    return this.http.get<any>(this.config.api + '/api/complianceareas/updates/count')
      ;
  }

  getComplianceAreaUpdate(tenantName: string = null) {

    if (tenantName == null){
      tenantName = LoginHelper.getTenantName();
      if (tenantName == null || LoginHelper.getUserToken() == null){
        this.authenticationService.logout();

        return null;
      }
    }

    return this.http.get<any>(this.config.api + '/api/complianceareas/updates')
      ;
  }


  @Load()
  approveUpdates(areaIds: any[], tenantName: string = null) {

    if (tenantName == null){
      tenantName = LoginHelper.getTenantName();
      if (tenantName == null || LoginHelper.getUserToken() == null){
        this.authenticationService.logout();

        return null;
      }
    }

    return this.http.post<any>(this.config.api + '/api/complianceareas/updates/accept', areaIds);
  }


  @Load()
  rejectUpdates(areaIds: any[], tenantName: string = null) {

    if (tenantName == null){
      tenantName = LoginHelper.getTenantName();
      if (tenantName == null || LoginHelper.getUserToken() == null){
        this.authenticationService.logout();

        return null;
      }
    }

    return this.http.post<any>(this.config.api + '/api/complianceareas/updates/reject', areaIds);
  }

  @Load()
  update(complianceArea: ComplianceArea, tenantName: string = null) {

    if (tenantName == null){
      tenantName = LoginHelper.getTenantName();
      if (tenantName == null || LoginHelper.getUserToken() == null){
        this.authenticationService.logout();

        return null;
      }
    }

    return this.http.post<any>(this.config.api + '/api/complianceareas', complianceArea);
  }


  downloadTemplate(): Observable<any> {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
            this.authenticationService.logout();

            return null;
        }

        return this.http
            .get(this.config.api + '/api/complianceareas/800-171', {responseType: 'arraybuffer'});
    }
}
